import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { toast } from 'react-toastify'
import config from '../../config'
import { loginUser } from '../../ducks/auth'
import whiteArrow from '../../images/right-arrow-white.png'
import routes from '../../routes'
import { ForgetPassword } from './ForgetPassword'
import { LoginPageStyle } from './styled'

export const LoginPage = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [agree, setAgree] = useState(false)
  const [expand, setExpand] = useState(false)

  const { isFetching, isAuthenticated } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const handleCheckBox = (e) => {
    setAgree(!agree)
    setExpand(true)
  }

  const handleExpand = () => {
    setExpand(!expand)
  }

  const handleLogin = (e) => {
    e.preventDefault()
    if (!agree) {
      toast('Please indicate that you have read and agree to the Terms and Conditions and Privacy Notice before login')
      return
    }
    loginUser(dispatch, {
      email,
      password,
    })
  }
  const onPasswordInput = (e) => {
    setPassword(e.target.value)
  }

  const onEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  useEffect(() => {
    document.title = `${config.eventName} | Login`
  }, [])

  if (isAuthenticated) {
    return <Redirect to={routes.lobby} />
  } else {
    return (
      <LoginPageStyle>
        <>
          <form onSubmit={handleLogin}>
            <p className="title">Login</p>
            <input type="email" placeholder="Email Address" value={email} onChange={onEmailInput} />
            <input type="password" value={password} placeholder="Password" onChange={onPasswordInput} />

            <div className="privacy mb-2">
              <div className="form-check">
                <input type="checkbox" className="agree-box" checked={agree} onClick={handleCheckBox} />
                <label className="form-check-label text-left" onClick={handleCheckBox}>
                  <span className="text-danger">*</span>&nbsp; I acknowledge that I have read and understood this Notice and the purposes for which UTP will process my&nbsp;
                  <a href="https://drive.google.com/file/d/1MLZeSDZR44UohC-2Bj0WaN9C1NYGDNmS/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                  Personal Data
                  </a>
                  {expand ? (
                    <span>
                      &nbsp;(including Sensitive Personal Data). I expressly consent to UTP processing my Personal Data (including my Sensitive Personal Data) in accordance with this Notice.
                    </span>
                  ) : (
                    <span onClick={handleExpand} className="text-secondary font-weight-bold readMore">
                      ...&nbsp;&nbsp;Read More
                    </span>
                  )}
                </label>
              </div>
            </div>

            <ForgetPassword />

            <div className="btn login-btn" onClick={handleLogin} style={{ background: isFetching ? 'lightgray' : '#10227A' }}>
              <input disabled={!(email.length && password.length) || isFetching} type="submit" value={isFetching ? '' : ''} />
              <div>
                <img src={whiteArrow} className="white-arrow" alt="icon" />
              </div>
            </div>

            {/* <div className="mt-4" id="support-link">
              <a href={`https://tawk.to/chat/600c31d4c31c9117cb71b3fa/1esnq5a0h`} target="_blank" rel="noopener noreferrer">
                Live Chat Support
              </a>
            </div> */}
          </form>
        </>
      </LoginPageStyle>
    )
  }
}
